(function(){
    var datepicker = {};
    datepicker.getMonthDate = function (year, month) {
        var ret = [];
        if((!year || !month)&& month !== 0){
            var today = new Date();
            year = today.getFullYear();
            month = today.getMonth() + 1;
        }
        var firstDay = new Date(year, month-1, 1);//获取当月第一天
        var firstDayWeekDay = firstDay.getDay();//获取星期几，才好判断排在第几列
        if(firstDayWeekDay === 0){//周日
            firstDayWeekDay = 7;
        }

        year = firstDay.getFullYear();
        month = firstDay.getMonth() + 1;

        var lastDayOfLastMonth = new Date(year, month-1, 0);//获取最后一天
        var lastDateOfLastMonth = lastDayOfLastMonth.getDate();

        var preMonthDayCount = firstDayWeekDay - 1;
        var lastDay = new Date(year, month, 0);
        var lastDate = lastDay.getDate();
        let monthEn = ''
        for(var i=0; i<7*6; i++){
            var date = i + 1 - preMonthDayCount;
            var showDate = date;
            var thisMonth = month;
            //上一月
            if(date <= 0){
                thisMonth = month - 1;
                showDate = lastDateOfLastMonth + date;
            }else if(date > lastDate){
                //下一月
                thisMonth = month + 1;
                showDate = showDate -lastDate;
            } 
            if(thisMonth === 0){
                thisMonth = 12;
            }
            if(thisMonth === 13){
                thisMonth = 1;
            }
            ret.push({
                month: thisMonth,
                date: date,
                showDate: showDate
            })
        }
        switch (month) {
            case 1:
                monthEn = 'January'
                break;
            case 2:
                monthEn = 'February'
                break;
            case 3:
                monthEn = 'March'
                break;
            case 4:
                monthEn = 'April'
                break;
            case 5:
                monthEn = 'May'
                break;
            case 6:
                monthEn = 'June'
                break;
            case 7:
                monthEn = 'July'
                break;
            case 8:
                monthEn = 'August'
                break;
            case 9:
                monthEn = 'September'
                break;
            case 10:
                monthEn = 'October'
                break;
            case 11:
                monthEn = 'November'
                break;
            case 12:
                monthEn = 'December'
                break;
            default:
                break;
        }
        return {
            year: year,
            month:month,
            monthEn: monthEn,
            days: ret
        };
    }
    window.datepicker = datepicker;//该函数唯一暴露的对象
})();